import KineticEnergy from './containers/KineticEnergy';
export default KineticEnergy;